module.exports = __webpack_public_path__ + "static/media/testBg.9b59a980.png";